
export const mimeTypes = file => new Promise((resolve, reject) => {
  if (!file) return
  getFile(file)
    .then(response => {
      // console.log(response)
      resolve(mimeFilter(response))
    })
})

const getFile = file => new Promise((resolve, reject) => {
  const xhttp = new XMLHttpRequest()
  xhttp.open('HEAD', file)
  xhttp.onreadystatechange = function () {
      if (this.readyState == this.DONE) {
          resolve(this.getResponseHeader("Content-Type"))
          // console.log(this.getResponseHeader("Content-Type"))
      }
  }
  xhttp.send()
})

const mimeFilter = mime => {
  switch (mime) {
    case 'image/jpg;':
      return
      break
    case 'image/jpeg;':
      return
      break
    case 'image/png;':
      return
      break
    case 'image/gif;':
      return
      break
    case 'image/tiff;':
      return
      break
    case 'image/bmp;':
      return
      break

    case 'application/pdf;':
      return 'icon-pdf.svg'
      break

    case 'application/doc;':
      return 'icon-doc.svg'
      break
    case 'application/docx;':
      return 'icon-docx.svg'
      break
  
    case 'application/xls;':
      return 'icon-xls.svg'
      break
    case 'application/xlsx;':
      return 'icon-xlsx.svg'
      break

    case 'application/ppt;':
      return 'icon-ppt.svg'
      break
    case 'application/pptx;':
      return 'icon-ppt.svg'
      break

    default: return 'icon-doc.svg'
  }
}
